import "@fontsource/playfair-display"; // or "@fontsource/playfair-display/700.css"
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store, persistor } from './store/store'; // ✅ import persistor
import { PersistGate } from 'redux-persist/integration/react'; // ✅ import PersistGate

import "./index.css";

import './App.css';



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
